import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PART_TYPE_META } from "./partTypes";
import { api } from "./api";

const cache = {};
let countsCache = null;

export const usePartTypeCounts = () => {
  const [counts, setCounts] = useState(countsCache);
  useEffect(() => {
    if (countsCache) return;
    api
      .get("/part-types")
      .then((r) => {
        countsCache = Object.fromEntries(r.data.map((x) => [x.slug, x.count]));
        setCounts(countsCache);
      })
      .catch(() => {});
  }, []);
  return counts;
};

export const usePartTypeMeta = () => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);
  const [dict, setDict] = useState(cache[lang] || null);
  useEffect(() => {
    if (lang === "en") {
      setDict(null);
      return;
    }
    if (cache[lang]) {
      setDict(cache[lang]);
      return;
    }
    setDict(null);
    import(`./parttypes-i18n/${lang}.json`)
      .then((m) => {
        cache[lang] = m.default || m;
        setDict(cache[lang]);
      })
      .catch(() => setDict(null));
  }, [lang]);
  return (slug) => {
    const base = PART_TYPE_META[slug];
    if (!base) return base;
    return dict?.[slug] ? { ...base, ...dict[slug] } : base;
  };
};
